import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { InboxPage } from "../notifications/inbox-page.tsx";
import { loadInbox } from "../notifications/loaders.ts";
import { InboxPending } from "../notifications/pending.tsx";
import { notificationsSearch } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/_app/notifications");

const Page = (): ReactElement => {
  const viewer = useViewer();
  const { tab = "all" } = route.useSearch();
  const navigate = route.useNavigate();
  return viewer === null ? (
    <NoAccessPage />
  ) : (
    <InboxPage
      viewer={viewer}
      tab={tab}
      onTabChange={(next) => {
        void navigate({ search: next === "all" ? {} : { tab: next }, replace: true });
      }}
    />
  );
};

export const Route = createFileRoute("/_app/notifications")({
  validateSearch: notificationsSearch,
  loader: async ({ context }) => loadInbox(context.data),
  pendingComponent: InboxPending,
  component: Page,
});
